import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter35 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 35 */}
                <section id="section35" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter35Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter35Paragraph1}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter35Paragraph2}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter35Paragraph3}

                    </p>

                    <h3 className="drivers-handbook-subheading">{language.chapter35SubTitle1}</h3>

                    <ul className="drivers-handbook-list">
                        <li>{language.chapter35List11}</li>
                        <li>{language.chapter35List12}</li>
                        <li>{language.chapter35List13}</li>
                        <li>{language.chapter35List14}</li>
                        <li>{language.chapter35List15}</li>
                    </ul>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter35Paragraph41}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter35Paragraph42}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter35Paragraph43}
                    </p>
                    <p className="drivers-handbook-paragraph">
                         {language.chapter35Paragraph5}
                    </p>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter35List51}</li>
                        <li>{language.chapter35List52}</li>
                        <li>{language.chapter35List53}</li>
                        <li>{language.chapter35List54}</li>
                        <li>{language.chapter35List55}</li>
                        <li>{language.chapter35List56}</li>
                    </ul>

                    <p className="drivers-handbook-paragraph">
                         {language.chapter35Paragraph6}
                    </p>
                </section>

        </>
    )

}

export default Chapter35;
